<template>
    <div id="indexLizi">
        <!-- <div class="sys-title">智慧水务管理平台</div>
        <div class="flex menu" style="z-index: 99;height: 100%;padding-top:30px;">
            <div  style="width: 100%" class="flex flex-center">
                <a-row style="width:100%" :gutter="60">
                    <a-col :span="12" style="margin-bottom: 25px" v-for="(item,index) in list" :key="item.key"> 
                        <div class="flex " :style="{'justify-content': index%2==0?'end': 'start'}" style="height: 210px" >
                            <div @click="goDetailPage(item)" class="flex-center single" :style="{background: item.color}" style="height: 100%;width: 80%;max-width: 640px;text-align: center;flex-direction:row;cursor: pointer;border-radius: 8px">
                                <div class="flex" style="margin-left: 80px">
                                    <img class="item-image" :src="item.imgSrc" />
                                </div>
                                <div class="item-bg" style="text-align: left;margin-left: 30px">
                                    <p class="item-title">{{item.title}}</p>
                                    <p class="item-title-detail">{{ $t(item.detail) }}</p>
                                </div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div> -->
        <div class="lang-switch">
          <LanguageSwitch />
        </div>
        <div class="home-box">
          <div class="handle-title">{{ $t('智慧水务管理平台') }}</div>
          <a-row :gutter="60" style="padding-top: 40px;width: 80%;">
              <a-col :span="item.key == 5 || item.key == 4 || item.key == 10 || item.key == 12 || item.key == 11?8:4" style="margin-bottom: 25px" v-for="(item,index) in list" :key="item.key"> 
                  <div @click="goDetailPage(item)" :style="{background: item.color}" class="item-box">
                      <div class="item-img">
                          <img :src="item.imgSrc" style="width: 60px;height: 60px;" />
                      </div>
                      <div class="item-title">
                          {{item.title}}
                      </div>
                  </div>
              </a-col>
          </a-row>
        </div>
    </div>
</template>
<!--<script src="./chaifen.js"></script>-->
<script>
import './chaifen.js'
import Vue from 'vue'
import { SYS_TYPE } from "@/store/mutation-types"
  import store from '@/store/'
  import {hasBtnAuthByCode} from '@/utils/util'
  import { mapState, mapActions,mapGetters } from 'vuex'
  import LanguageSwitch from '@/components/tools/LanguageSwitch'
export default {
    components: {
        LanguageSwitch
    },
    data() {
        return {
            interval: null,
            triangleImageUrl: require("@/assets/images/triangle.png"),
            circleImageUrl: require("@/assets/images/item-bg.png"),
            circleImageHeighLightUrl: require("@/assets/images/item-bg-heighlight.png")
        }
    },
    mounted() {
        this.$nextTick(()=> {
            // this.liziInit(window.Myi);
        })
        
    },
    created() {
        // let meterMaintenanceBtnAuth = hasBtnAuthByCode("maintenance:show");
        // if(meterMaintenanceBtnAuth) {
        //     this.list.push({title: '运维管理',key: 7,imgSrc: require("@/assets/images/menu-yw.png"),authAction: 'maintenance:show',color: '#05AFFF'})
        // }
    },
    computed:{
        ...mapGetters({
        permissionMenuList: 'menusData'
      }),
      // i18n：入口标题使用 computed 以响应语言切换
      list() {
          return [
              {title: this.$t('表务管理'),key: 9,imgSrc: require("@/assets/images/menu-meter.png"),color: '#3D7BEC',detail: '水表全生命周期的管理'},
              {title: this.$t('管网监测'),key: 3,imgSrc: require("@/assets/images/menu-waterQuality.png"),color: '#3DE5C3',detail: '管网监测'},
              {title: this.$t('集中抄表'),key: 8,imgSrc: require("@/assets/images/menu-image.png"),color: '#069CFF',detail: '各种远传设备的数据集采'},
              {title: this.$t('营业收费'),key: 4,imgSrc: require("@/assets/images/menu-yy.png"),color: '#2EBFE6',detail: '根据用水计量数据，自动计算用户的水费，并提供多种收费方式'},
              //{title: '一张图',key: 1,imgSrc: require("@/assets/images/menu-image.png"),authAction: 'photoDevice:show',color: '#00A2FF'},
              {title: this.$t('智慧水务大屏'),key: 2,imgSrc: require("@/assets/images/menu-data.png"),authAction: 'screen:show',color: '#06C0FF',detail: '展现关键指标，以图形、报表、滚动提醒、动态闪烁等多种方式展示'},
              //{title: '水质监测系统',key: 3,imgSrc: require("@/assets/images/menu-waterQuality.png"),authAction: 'waterQuality:show',color: '#3DE5C3'},
              {title: this.$t('通知中心'),key: 16,imgSrc: require("@/assets/images/menu-dx.png"),authAction: 'screen:show',color: '#53C3BC',detail: '基于流程引擎平台搭建工单平台'},
              {title: this.$t('工单管理'),key: 10,imgSrc: require("@/assets/images/menu-gd.png"),color: '#06C0C2',detail: '基于流程引擎平台搭建工单平台'},

              {title: this.$t('巡检管理'),key: 6,imgSrc: require("@/assets/images/menu-xc.png"),color: '#6A8FFF',detail: '巡检业务流程化管理'},
              {title: this.$t('工程报装'),key: 11,imgSrc: require("@/assets/images/menu-bz.png"),color: '#DFB673',detail: '基于流程引擎平台搭建工单平台'},
              //{title: '运维管理',key: 7,imgSrc: require("@/assets/images/menu-xc.png")}
              {title: this.$t('客服热线'),key: 12,imgSrc: require("@/assets/images/menu-rx.png"),color: '#68A1FF',detail: '人工坐席管理、单据处理、话务管理、大屏幕管理、客户满意度调查'},
              {title: this.$t('DMA分区计量'),key: 5,imgSrc: require("@/assets/images/menu-dma.png"),color: '#2EBFE6',detail: '包含DMA分区管理、分区流量监测、分区压力监测、分区漏损评估等'},

              {title: this.$t('OA办公'),key: 13,imgSrc: require("@/assets/images/menu-oa.png"),color: '#06B5E4',detail: '适合水务公司的小型协同管理工作平台,实现部分办公系统智能化及自动化'},
              // {title: '数据中心',key: 14,imgSrc: require("@/assets/images/menu-sj.png"),color: '#5594FC',detail: '多种方式实现数据集成、信息发布、任务提醒、数据分析、指标订阅、异常告警等，实现多系统一站登录，全平台统一管理'},
              {title: this.$t('系统管理'),key: 15,imgSrc: require("@/assets/images/menu-sj.png"),color: '#00CCFF',detail: '进行系统设置'},
          ]
      }
    },

    methods: {
        goDetailPage(item) {
            if(item.authAction) {
                if(!hasBtnAuthByCode(item.authAction)) {
                    this.$error({
                        title: this.$t('提示'),
                        content: this.$t('您暂无权限访问，请联系管理员！'),
                    });
                    return;
                }
            }
            if(item.key == 1) {
                this.$router.push({ path: "/bigScreen/photoDevice" })
            }else if(item.key ==  2) {
                this.$router.push({ path: "/bigScreen/screen" })
            }else if(item.key == 4) {
                Vue.ls.set(SYS_TYPE,1);
                store.commit('SET_SYSTYPE', 1);
                this.setpermission("/dashboard/analysis");
            } else if(item.key == 3){
                Vue.ls.set(SYS_TYPE,2);
                store.commit('SET_SYSTYPE', 2);
                this.setpermission("/websiteMonitoring/MeterDeviceBaseList");
            }else if(item.key == 7){
                Vue.ls.set(SYS_TYPE,3);
                store.commit('SET_SYSTYPE', 3);
                this.setpermission("maintenanceDevice/batteryVoltageList");
            }else if(item.key == 9){
                Vue.ls.set(SYS_TYPE,4);
                store.commit('SET_SYSTYPE', 4);
                // this.setpermission("/meterManagement/meterUserInfoList");
                this.setpermission("/meterManagement/meterinfoList");
            }else if(item.key == 8){
                Vue.ls.set(SYS_TYPE,5);
                store.commit('SET_SYSTYPE', 5);
                this.setpermission("/InternetDeviceManagement/MeterUpDataList");
            }else if(item.key == 11){
              Vue.ls.set(SYS_TYPE,7);
              store.commit('SET_SYSTYPE', 7);
              this.setpermission("/engineeringInstallation/home");
            }else if(item.key == 15){
              Vue.ls.set(SYS_TYPE,6);
              store.commit('SET_SYSTYPE', 6);
              this.setpermission("/isystem/user");
            }else if(item.key == 10){
              Vue.ls.set(SYS_TYPE,8);
              store.commit('SET_SYSTYPE', 8);
              this.setpermission("/workOrderManagement/home");
            }else if(item.key == 6){
              Vue.ls.set(SYS_TYPE,9);
              store.commit('SET_SYSTYPE', 9);
              this.setpermission("/inspectionManagement/home");
            }else if(item.key == 13){
              Vue.ls.set(SYS_TYPE,10);
              store.commit('SET_SYSTYPE', 10);
              this.setpermission("account/settings/Workplace");
            }else if(item.key == 12){
              Vue.ls.set(SYS_TYPE,11);
              store.commit('SET_SYSTYPE', 11);
              this.setpermission("/hotline/AttendantConsole/index")
            }else if(item.key == 5){
                Vue.ls.set(SYS_TYPE,12);
              store.commit('SET_SYSTYPE', 12);
              this.setpermission("/DMAPartitionMetering/PipelineNew/ComprehensiveDisplay");
            }else if(item.key == 14){
                Vue.ls.set(SYS_TYPE,1);
                store.commit('SET_SYSTYPE', 1);
                this.setpermission("/meterUserRecordList/MeterDailySaleWaterReportList");
            }else if(item.key == 16){
                Vue.ls.set(SYS_TYPE,13);
                store.commit('SET_SYSTYPE', 13);
                this.setpermission("/meterUseWarnManagement/meterUseWarnConfigList");
            }else {
                this.$error({
                    title: this.$t('提示'),
                    content: this.$t('您暂无权限访问，请联系管理员！'),
                });
            }
        },
        // 权限验证
        setpermission(path){
            if(!this.permissionMenuList||this.permissionMenuList.length==0){
                this.$error({
                    title: this.$t('提示'),
                    content: this.$t('您暂无权限访问，请联系管理员！'),
                });
                return;
            }else{
                this.$router.push({ path: path })
            }
        },
        liziInit(r) {
            var n, e, o, s, a, h, l, c = window.innerWidth, u = window.innerHeight, f = 90, m = 50, p = 50, d = 0, x = 0, g = window.innerWidth / 2, v = window.innerHeight / 2;
            function t(t) {
                d = t.clientX - g,
                x = t.clientY - v
            };
            function i() {
                a.position.x += .05 * (d - a.position.x),
                    a.position.y = 364;
                for (var t = 0, i = 0; i < m; i++)
                    for (var n = 0; n < p; n++)
                        o = e[t++],
                            o.position.y = 50 * Math.sin(.3 * (i + s)) + 50 * Math.sin(.5 * (n + s)),
                            o.scale.x = o.scale.y = 2 * (Math.sin(.3 * (i + s)) + 1) + 2 * (Math.sin(.5 * (n + s)) + 1);
                l.render(h, a),
                    s += .1
            };
            !function () {
                n = document.createElement("div"),
                    n.style.position = "relative",
                    n.style.top = "200px",
                    document.getElementById("indexLizi").appendChild(n),
                    a = new r.default.Camera(75, c / u, 1, 1e4),
                    a.position.z = 1e3,
                    h = new r.default.Scene,
                    l = new r.default.CanvasRenderer,
                    l.setSize(c, u),
                    e = new Array;
                for (var i = 0, d = new r.default.ParticleCircleMaterial(621531, 1), x = 0; x < m; x++)
                    for (var g = 0; g < p; g++)
                        o = e[i++] = new r.default.Particle(d),
                        o.position.x = x * f - m * f / 2,
                        o.position.z = g * f - p * f / 2,
                        h.add(o);
                        s = 0,
                    n.appendChild(l.domElement),
                    document.addEventListener("mousemove", t, !1)
            }()
            this.interval = setInterval(function(){i()}, 1e3 / 60)
        }
    },
    beforeDestroy(){
        clearInterval(this.interval)
        this.interval = null
    }
}
</script>
<style lang="less" scoped>
#indexLizi{
    height: 100vh;
    width: 100%;
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
    background: url('~@/assets/images/syshome-bg.png') #071737 no-repeat;
    background-size: 100% 100%;
    display: grid;
    place-items: center;

}
.lang-switch{
    position: absolute;
    top: 24px;
    right: 32px;
    z-index: 99;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    background: rgba(4, 26, 66, 0.65);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 16px;
    padding: 4px 14px;
    transition: background 0.3s;
    &:hover{
        background: rgba(4, 26, 66, 0.9);
    }
    /deep/ .ant-dropdown-trigger{
        color: #fff;
    }
}
.sys-title{
    color: #212D40;
    font-weight: 400;
    font-size: 21px;
    position: absolute;
    top: 30px;
    left: 30px
}
.item-title{
    font-size: 30px;
    font-weight: 800;
    color: #fff;
    margin-bottom: 5px;
}
.item-title-detail{
    font-size: 18px;
    color: #fff;
}
.item-bg{
    position: relative;
    flex: 1;
}
@keyframes hovertriangle {
    0% {
        transform: scale(0.1);
    }
    100% {
        transform: scale(1.1);
    }
}
@keyframes hovercircle{
    0% {
        transform: translate(-50%,-50%) rotate(0deg);
    }
    50% {
        transform: translate(-50%,-50%) rotate(45deg);
    }
    100% {
        transform: translate(-50%,-50%) rotate(0deg);
    }
}
.single:hover{
    .item-title{
        color: #00FAFE;
    }
    .triangle{
        opacity: 1;
        animation: hovertriangle 2s infinite;
    }
    .circle-image-heighlight{
        opacity: 1;
        animation: hovercircle 2s infinite;
    }
    .circle-image{
        opacity: 0;
        
    }
    .item-image {
        animation: hovertriangle 2s infinite;
    }
}
.menu{
    width: 100%;
    height: calc(100% - 100px);
}
.item-image{
  
}
.circle-image-heighlight{
    opacity: 0;
}
.triangle {
    opacity: 0;
    top: 40%;
}
.flex-row{
    flex-direction: row;
}
.ant-col-4,
.ant-col-8{
  padding-left: 5px !important;
  padding-right: 5px !important;
  margin-bottom: 10px !important;
}
.home-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .handle-title{
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  .item-box{
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    .item-title{
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      margin-top: 5px;
    }
    &:hover{
      .item-img{
        // transform: translateY(-120px);
        // transition: 0.4s ease-in-out 0.2s;
        // opacity: 0.3;
        animation: hoverImg 2s infinite;
      }
    }
  }
}
@keyframes hoverImg {
  0% {
      transform: scale(0.3);
  }
  100% {
      transform: scale(1.5);
  }
}
</style>